import feathersClient, {BaseModel, makeServicePlugin} from '../../feathers-client'

class Feature extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'Feature';

    // Define default properties here
    static instanceDefaults() {
        return {
            name: '',
            feature_id: ''
        }
    }
}

const servicePath = 'features';
const servicePlugin = makeServicePlugin({
    Model: Feature,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin